const INITIAL_STATE = {
  data: {},
  errors: {},
}

const addStaxPaymentInfo = (state = INITIAL_STATE, action) => {
  switch(action.type) {
  case 'ADD_STAX_PAYMENT_INFO':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'ADD_STAX_PAYMENT_INFO_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return {...state}
  }
}

export default addStaxPaymentInfo;